import store from '@store'
import * as types from '@store/types'
import searchRoutes from '@content/searchComponents'

export default [
  {
    path: '/',
    redirect: '/dashboard',
    component: () => import('@views/Logged'),
    beforeEnter: async (to, from, next) => {
      const auth = await store.getters[types.AUTH]
      const expired = Date.now() > auth.expires_at

      if (!auth.token || expired) {
        store.dispatch(types.NOTIFICATIONS_INCLUDE, Error('Entre com suas credenciais para acessar essa página.'))
        next({
          name: 'Login',
          params: { redirect: to.path }
        })
        return
      }
      next()
    },
    children: [
      {
        path: '/awards',
        name: 'Prêmios',
        meta: { crumb: { text: 'Prêmios' } },
        component: () => import('@views/Awards')
      },
      {
        path: '/engagement',
        name: 'Pontos',
        meta: { crumb: { text: 'Pontos' } },
        component: () => import('@views/Engagement')
      },
      {
        path: 'dashboard',
        component: () => import('@views/Dashboard'),
        redirect: '/perks'
      }, {
        path: '/perks',
        meta: { crumb: { text: 'Parceiros' } },
        component: () => import('@views/Perks'),
        children: [
          {
            path: '',
            name: 'Parceiros',
            component: () => import('@containers/Perk/PerkAll')
          }, {
            path: 'new',
            name: 'Novo parceiro',
            meta: { crumb: { text: 'Criar' } },
            component: () => import('@containers/Perk/PerkForm'),
            beforeEnter: async (to, from, next) => {
              if (from.params.accountId) {
                await store.dispatch(types.ACCOUNT, {
                  id: from.params.accountId,
                  includeDetails: false
                })
              }
              next()
            }
          }, {
            path: ':perkId',
            component: () => import('@views/Perk'),
            meta: {
              crumb: {
                dynamic: true,
                getter: types.PERK_DETAILS,
                text: details => details.name || details.id
              }
            },
            beforeEnter: async (to, from, next) => {
              const perkId = to.params.perkId
              if (!perkId) {
                next('/perks')
                return
              }
              const isEdit = to.name === 'Editar parceiro'
              const { data: { data: { partner } } } = await store.dispatch(types.PERK_DETAILS, { perkId, isEdit })
              const accountId = (partner && partner.company_id) || from.params.accountId
              if (accountId) {
                await store.dispatch(types.ACCOUNT, {
                  id: accountId,
                  includeDetails: false,
                  getClient: true
                })
              }

              next()
            },
            children: [
              {
                path: '',
                name: 'Parceiro',
                component: () => import('@containers/Perk/PerkInformation')
              },
              {
                path: 'edit',
                name: 'Editar parceiro',
                meta: { crumb: { text: 'Editar' } },
                component: () => import('@containers/Perk/PerkForm'),
                beforeEnter: async (to, from, next) => {
                  const perkId = to.params.perkId
                  if (!perkId) {
                    next('/perks')
                  }
                  await store.dispatch(types.PERK_DETAILS, { perkId, isEdit: true })
                  next()
                }
              },
              {
                path: 'addresses',
                name: 'Endereços',
                meta: { crumb: { text: 'Endereços' } },
                component: () => import('@containers/Perk/PerkAddress'),
                beforeEnter: async (to, from, next) => {
                  const perkId = to.params.perkId
                  if (!perkId) {
                    next('/perks')
                  }

                  await store.dispatch(types.PERK_DETAILS, { perkId })
                  next()
                }
              },
              {
                path: 'campaigns',
                meta: { crumb: { text: 'Ofertas' } },
                component: () => import('@views/Campaigns'),
                children: [
                  {
                    path: '',
                    name: 'Ofertas',
                    component: () => import('@containers/Campaign/CampaignList')
                  },
                  {
                    path: 'new',
                    name: 'Nova Oferta',
                    meta: { crumb: { text: 'Nova Oferta' } },
                    component: () => import('@containers/Campaign/CampaignForm'),
                    beforeEnter: async (to, from, next) => {
                      const { perkId } = to.params
                      if (!perkId) { next({ name: 'Ofertas' }) }
                      await Promise.all([
                        store.dispatch(types.ADDRESSES, { partner: perkId }),
                        store.dispatch(types.TAGS)
                      ])
                      next()
                    }
                  },
                  {
                    path: ':campaignId',
                    name: 'Oferta',
                    meta: {
                      crumb: {
                        dynamic: true,
                        getter: types.CAMPAIGN_DETAILS,
                        text: details => details.name || details.id
                      }
                    },
                    component: () => import('@containers/Campaign/CampaignInformation')
                  },
                  {
                    path: ':campaignId/edit',
                    name: 'Editar Oferta',
                    meta: {
                      crumb: {
                        dynamic: true,
                        getter: types.CAMPAIGN_DETAILS,
                        text: details => details.name
                      }
                    },
                    component: () => import('@containers/Campaign/CampaignForm'),
                    beforeEnter: async (to, from, next) => {
                      const { perkId, campaignId } = to.params
                      if (!campaignId || !perkId) { next({ name: 'Ofertas' }) }
                      await Promise.all([
                        store.dispatch(types.CAMPAIGN_DETAILS, { perkId, campaignId, type: 'edit' }),
                        store.dispatch(types.ADDRESSES, { partner: perkId }),
                        store.dispatch(types.TAGS)
                      ])
                      next()
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/communication',
        redirect: 'communication/email',
        meta: { crumb: { text: 'Comunicação' } },
        component: () => import('@views/Communication'),
        children: [
          {
            path: 'email',
            name: 'Comunicação por Email',
            component: () => import('@containers/Communication/Email/EmailCommunicationContainer')
          },
          {
            path: 'email-new',
            meta: { crumb: { text: 'Disparo de e-mail' } },
            name: 'Disparo de e-mail',
            component: () => import('@containers/Communication/Email/NewEmailForm')
          }
        ]
      },
      {
        path: '/rescues',
        meta: { crumb: { text: 'Resgates' } },
        component: () => import('@views/Rescues'),
        children: [
          {
            path: '',
            name: 'Resgates',
            component: () => import('@containers/Rescues/RescuesContainer')
          },
          {
            path: 'vouchers',
            name: 'Codigos unicos',
            component: () => import('@views/Vouchers')
          },
          {
            path: 'purchases',
            redirect: 'purchases/extract',
            meta: { crumb: { text: 'Compras' } },
            name: 'Compras',
            component: () => import('@views/Purchases'),
            children: [
              {
                path: 'extract',
                meta: { crumb: { text: 'Extrato' } },
                name: 'Extratos',
                component: () => import('@containers/Rescues/Purchases/ExtractContainer')
              }
            ]
          },
          {
            path: 'withdrawals',
            redirect: 'withdrawals/resume',
            component: () => import('@views/Withdrawal'),
            children: [
              {
                path: 'resume',
                meta: { crumb: { text: 'Saques resumo' } },
                name: 'Saques resumo',
                component: () => import('@containers/Rescues/Withdrawals/SummaryContainer.vue')
              },
              {
                path: 'cashback-new',
                meta: { crumb: { text: 'Adição manual' } },
                name: 'Adição manual',
                component: () => import('@containers/Rescues/Withdrawals/SummaryForm.vue')

              },
              {
                path: 'rescue',
                meta: { crumb: { text: 'Cashback resgate' } },
                name: 'Cashback resgate',
                component: () => import('@containers/Rescues/Withdrawals/RescueContainer')
              }
            ]
          },
          {
            path: 'chargebacks',
            redirect: 'chargebacks/resume',
            component: () => import('@views/Chargebacks'),
            children: [
              {
                path: 'resume',
                meta: { crumb: { text: 'Resumo Chargebacks' } },
                name: 'Resumo Chargebacks',
                component: () => import('@containers/Rescues/Chargebacks/ChargebackContainer')
              }
            ]
          }
        ]
      },
      {
        path: '/wallet',
        redirect: 'wallet/entries',
        meta: { crumb: { text: 'Carteira' } },
        component: () => import('@views/Wallet'),
        children: [
          {
            path: 'entries',
            name: 'Entradas na carteira',
            component: () => import('@containers/Wallet/EntriesContainer')
          },
          {
            path: 'outflows',
            name: 'Saídas na carteira',
            component: () => import('@containers/Wallet/OutflowsContainer')
          }
        ]
      },
      {
        path: '/giftcards',
        redirect: 'giftcards/todo',
        meta: { crumb: { text: 'Gift Cards' } },
        component: () => import('@views/GiftCards'),
        children: [
          {
            path: 'todo',
            name: 'Todo',
            component: () => import('@containers/GiftCards/GiftCardsTodoContainer')
          },
          {
            path: 'epay',
            name: 'Epay',
            component: () => import('@containers/GiftCards/GiftCardsEpayContainer')
          }
        ]
      },
      {
        path: '/users',
        meta: { crumb: { text: 'Usuários' } },
        component: () => import('@views/Users'),
        children: [
          {
            path: '',
            name: 'Usuários',
            component: () => import('@containers/Users/UserList')
          },
          {
            path: 'new',
            name: 'Criar usuário',
            component: () => import('@containers/Users/UserForm')
          },
          {
            path: ':userId/edit',
            name: 'Editar usuário',
            component: () => import('@containers/Users/UserForm')
          },
          {
            path: 'import',
            name: 'Importar usuários',
            component: () => import('@containers/Users/UserImport')
          }
        ]
      },
      {
        path: '/medias',
        redirect: 'medias/banner',
        meta: { crumb: { text: 'Mídias' } },
        component: () => import('@views/Medias'),
        children: [
          {
            path: 'banner',
            component: () => import('@views/Banners'),
            children: [
              {
                path: '',
                name: 'Banners',
                component: () => import('@containers/Medias/Banners/BannerList')
              },
              {
                path: 'new',
                name: 'Criar banner',
                component: () => import('@containers/Medias/Banners/BannerForm')
              },
              {
                path: ':bannerId/edit',
                name: 'Editar banner',
                component: () => import('@containers/Medias/Banners/BannerForm')
              }
            ]
          },
          {
            path: 'popup',
            name: 'Pop-up',
            meta: { crumb: { text: 'Pop-up' } },
            component: () => import('@containers/Medias/Popups/PopupContainer')
          }
        ]
      },
      {
        path: '/clients',
        meta: { crumb: { text: 'Clientes' } },
        component: () => import('@views/Clients'),
        children: [
          {
            path: '',
            name: 'Clientes',
            component: () => import('@containers/Client/ClientTable')
          }, {
            path: 'new',
            name: 'Criar cliente',
            meta: { crumb: { text: 'Criar' } },
            component: () => import('@containers/Client/ClientForm'),
            beforeEnter: async (to, from, next) => {
              await store.dispatch(types.CLIENT_CLEAR)
              next()
            }
          },
          {
            path: ':clientId',
            meta: {
              crumb: {
                dynamic: true,
                getter: types.CLIENT,
                text: client => client.name
              }
            },
            component: () => import('@views/Client'),
            beforeEnter: async (to, from, next) => {
              const clientId = to.params.clientId
              if (!clientId) { next('/clients') }
              if (to.name !== 'Editar') {
                await store.dispatch(types.CLIENT, { id: clientId })
              }
              next()
            },
            children: [
              {
                path: '',
                name: 'Resumo do cliente',
                component: () => import('@containers/Client/ClientResume')
              }, {
                path: 'edit',
                name: 'Editar cliente',
                component: () => import('@containers/Client/ClientForm')
              }, {
                path: 'accounts',
                name: 'Contas do cliente',
                meta: { crumb: { text: 'Contas' } },
                component: () => import('@containers/Client/ClientAccounts'),
                children: [
                  {
                    path: 'new',
                    name: 'Criar conta',
                    meta: { crumb: { text: 'Criar' } },
                    component: () => import('@containers/Account/AccountForm')
                  }, {
                    path: ':accountId',
                    meta: {
                      crumb: {
                        dynamic: true,
                        getter: types.ACCOUNT,
                        text: account => account.name
                      }
                    },
                    component: () => import('@views/Account'),
                    children: [
                      {
                        path: '',
                        name: 'Resumo da conta',
                        component: () => import('@containers/Account/AccountDetails')
                      }, {
                        path: 'block',
                        name: 'Bloquear parceiros da conta',
                        meta: { crumb: { text: 'Bloquear' } },
                        component: () => import('@containers/Account/AccountPartnersBlock')
                      }, {
                        path: 'customize',
                        name: 'Personalização da conta',
                        meta: { crumb: { text: 'Personalização' } },
                        component: () => import('@containers/Account/AccountCustomization')
                      }, {
                        path: 'highlights',
                        name: 'Destaques da conta',
                        meta: { crumb: { text: 'Destaques' } },
                        component: () => import('@containers/Account/AccountHighlights')
                      }, {
                        path: 'import',
                        name: 'Importação de base da conta',
                        meta: { crumb: { text: 'Importação' } },
                        component: () => import('@containers/Account/AccountImport')
                      }, {
                        path: 'perks',
                        name: 'Parceiros exclusivos',
                        meta: { crumb: { text: 'Parceiros exclusivos' } },
                        component: () => import('@containers/Account/AccountPerks')
                      }, {
                        path: 'wallet',
                        name: 'Carteira do usuario',
                        meta: { crumb: { text: 'Carteira' } },
                        component: () => import('@containers/Account/AccountWallet')
                      }, {
                        path: 'urls',
                        name: 'Urls da conta',
                        meta: { crumb: { text: 'urls' } },
                        component: () => import('@containers/Account/AccountUrls')
                      }, {
                        path: 'edit',
                        name: 'Editar conta',
                        meta: { crumb: { text: 'Editar' } },
                        component: () => import('@containers/Account/AccountForm')
                      }
                    ]
                  }
                ]
              }, {
                path: 'products',
                name: 'Produtos do cliente',
                meta: { crumb: { text: 'Produtos' } },
                component: () => import('@containers/Client/ClientProducts')
              },
              {
                path: 'address',
                name: 'Contato do cliente',
                meta: { crumb: { text: 'Contato' } },
                component: () => import('@containers/Client/ClientContact')
              }
            ]
          }
        ]
      },
      {
        path: '/tags',
        name: 'Tags',
        meta: { crumb: { text: 'Tags' } },
        component: () => import('@views/Tags')
      },
      {
        path: '/academy',
        name: 'Academy',
        meta: { crumb: { text: 'Academy' } },
        component: () => import('@views/Academy'),
        children: [
          {
            path: 'lessons',
            name: 'lessons',
            component: () => import('@containers/Academy/Lessons/Lessons')
          },
          {
            path: 'lessons/create',
            name: 'createLesson',
            component: () => import('@containers/Academy/Lessons/CreateLesson')
          },
          {
            path: 'lessons/:id/edit',
            name: 'editLesson',
            component: () => import('@containers/Academy/Lessons/CreateLesson')
          },
          {
            path: 'articles',
            name: 'articles',
            component: () => import('@containers/Academy/Articles')
          },
          {
            path: 'articles/create',
            name: 'createArticle',
            component: () => import('@containers/Academy/Articles/CreateArticle')
          },
          {
            path: 'articles/:id/edit',
            name: 'editArticle',
            component: () => import('@containers/Academy/Articles/CreateArticle')
          },
          {
            path: 'modules',
            name: 'modules',
            component: () => import('@containers/Academy/Modules')
          },
          {
            path: 'subjects',
            name: 'subjects',
            component: () => import('@containers/Academy/Subjects')
          }
        ]
      },
      {
        path: '/notifications',
        meta: { crumb: { text: 'Notificações' } },
        component: () => import('@views/Notifications'),
        children: [
          {
            path: '',
            name: 'Notificações',
            component: () => import('@containers/Notifications/NotificationList')
          },
          {
            path: 'new',
            name: 'Criar notificação',
            component: () => import('@containers/Notifications/NotificationForm')
          },
          {
            path: ':notificationId/edit',
            name: 'Editar notificação',
            component: () => import('@containers/Notifications/NotificationForm')
          }
        ]
      },
      {
        path: '/reports',
        name: 'Relatórios',
        meta: { crumb: { text: 'Relatórios' } },
        component: () => import('@views/Reports')
      }, {
        path: '/search',
        redirect: { name: 'Busca - Clientes' },
        component: () => import('@views/Search'),
        children: [
          ...searchRoutes.map(_ => ({
            name: _.name,
            path: _.path,
            component: () => import('@containers/Search/SearchResults')
          }))
        ]
      }
    ]
  }, {
    path: '/login',
    name: 'Login',
    component: () => import('@containers/Login/LoginContainer')
  }, {
    path: '*',
    name: '404',
    component: () => import('@views/404')
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js